const Enrollment = () => {


      const win = window.open(" https://forms.gle/dQM6CPgAXiagLgBD6", '_blank');
      console.log("speaked")
    if (win != null) {
      win.focus();
    }
  }

export default Enrollment